document.querySelectorAll('header .button-search').forEach(button => {

    button.addEventListener('click', (e)=>{

        if(e.target.closest('.container').querySelector('.header__search-container').classList.contains('active')){

            e.target.closest('.container').querySelector('.header__search-container').classList.remove('active');

        }else{

            e.target.closest('.container').querySelector('.header__search-container').classList.add('active');

        }

    });

})

document.querySelectorAll('header .header__search-container .search-panel__cancel').forEach(button => {

    button.addEventListener('click', (e)=>{

        if(e.target.closest('.container').querySelector('.header__search-container').classList.contains('active')){

            e.target.closest('.container').querySelector('.header__search-container').classList.remove('active');

        }else{

            e.target.closest('.container').querySelector('.header__search-container').classList.add('active');

        }

    });

})

document.querySelectorAll('header .city-changer').forEach(changer => {

    changer.addEventListener('click', (e) => {

        if(e.target.closest('.city-changer__icon') || e.target.closest('.city-changer__name')){

            if(e.target.closest('.city-changer').querySelector('.city-changer__city-list').classList.contains('active')){

                e.target.closest('.city-changer').querySelector('.city-changer__city-list').classList.remove('active');

            }else{

                e.target.closest('.city-changer').querySelector('.city-changer__city-list').classList.add('active');

            }

        }

    })

});

document.querySelector('body').addEventListener('click', (e) => {

    if(!e.target.closest('.city-changer__icon')&&!e.target.closest('.city-changer__name')&&!e.target.closest('.city-changer__city-list')){

        document.querySelectorAll('.city-changer__city-list').forEach(block => {

            block.classList.remove('active');

        })

    }

})

document.querySelector('.menu__button').addEventListener('click', (e) => {

    if(e.target.closest('.header__inner-container__mobile').querySelector('.header__mobile-menu-block').classList.contains('active')){

        e.target.closest('.header__inner-container__mobile').querySelector('.header__mobile-menu-block').classList.remove('active');
        e.target.closest('.header__inner-container__mobile').querySelector('.menu__button').classList.remove('active');
        document.querySelector('body').classList.remove('mobile-menu-active');

    }else{

        e.target.closest('.header__inner-container__mobile').querySelector('.header__mobile-menu-block').classList.add('active');
        e.target.closest('.header__inner-container__mobile').querySelector('.menu__button').classList.add('active');
        document.querySelector('body').classList.add('mobile-menu-active');

    }

})

if(document.querySelector('.home-slider')){

    const homeSwiper = new Swiper('.home-slider .swiper', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,

        // If we need pagination
        pagination: {
          el: '.swiper-pagination',
        },

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
    });

}

if(document.querySelector('#jewelry-slider')){

    const jewelrySwiper = new Swiper('#jewelry-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4,

        breakpoints: {
            // when window width is >= 320px
            1200: {
              slidesPerView: 4,
              spaceBetween: 16
            },
            760: {
                slidesPerView: 3,
                spaceBetween: 16,
                slidesPerGroup: 3
              },
            420: {
            slidesPerView: 2,
            spaceBetween: 16,
            slidesPerGroup: 2
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
                slidesPerGroup: 1
              }
        },

        // Navigation arrows
        navigation: {
          nextEl: '.jewelry-slider-navigation.swiper-button-next',
          prevEl: '.jewelry-slider-navigation.swiper-button-prev',
        },

        // If we need pagination
        pagination: {
            el: '.jewelry-slider-pagination',
        },

    });

}

if(document.querySelector('#relevant-products-slider')){

    const jewelrySwiper = new Swiper('#relevant-products-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4,

        breakpoints: {
            // when window width is >= 320px
            1200: {
              slidesPerView: 4,
              spaceBetween: 16
            },
            760: {
                slidesPerView: 3,
                spaceBetween: 16,
                slidesPerGroup: 3
              },
            420: {
            slidesPerView: 2,
            spaceBetween: 16,
            slidesPerGroup: 2
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
                slidesPerGroup: 1
              }
        },

        // Navigation arrows
        navigation: {
          nextEl: '.product-slider-navigation.swiper-button-next',
          prevEl: '.product-slider-navigation.swiper-button-prev',
        },

        // If we need pagination
        pagination: {
            el: '.product-slider-pagination',
        },

    });

}

if(document.querySelector('#bestsellers-slider')){

    const jewelrySwiper = new Swiper('#bestsellers-slider', {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3,

        breakpoints: {
            // when window width is >= 320px
            1200: {
              slidesPerView: 3,
              spaceBetween: 16,
              slidesPerGroup: 3
            },
            760: {
                slidesPerView: 3,
                spaceBetween: 16,
                slidesPerGroup: 3
              },
            420: {
            slidesPerView: 2,
            spaceBetween: 16,
            slidesPerGroup: 2
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 16,
                slidesPerGroup: 1
              }
        },

        // Navigation arrows
        navigation: {
          nextEl: '.bestsellers-slider-navigation.swiper-button-next',
          prevEl: '.bestsellers-slider-navigation.swiper-button-prev',
        },

        // If we need pagination
        pagination: {
            el: '.bestsellers-slider-pagination',
        },

    });

}

if(document.querySelector('#reviews-slider')){

    const jewelrySwiper = new Swiper('#reviews-slider', {
        // Optional parameters
        direction: 'horizontal',
        /* loop: true, */
        slidesPerView:'auto',
        spaceBetween: 30,
        slidesPerGroup: 1,

        breakpoints: {
            // when window width is >= 320px
            1200: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                slidesPerGroup: 1
            },
            759: {
                slidesPerView: 'auto',
                spaceBetween: 30,
                slidesPerGroup: 1
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
                slidesPerGroup: 1
            }
        },

        // Navigation arrows
        navigation: {
          nextEl: '.reviews-slider-button-next',
          prevEl: '.reviews-slider-button-prev',
        },

        // If we need pagination
        pagination: {
            el: '.reviews-slider-pagination',
        },

    });

}

if(document.querySelector('#content__price-range')){

    var content__priceRange = document.getElementById('content__price-range');

    noUiSlider.create(content__priceRange, {
        start: [27730, 547480],
        connect: true,
        step: 10,
        range: {
            'min': 1000,
            'max': 800000
        }
    });

    content__priceRange.noUiSlider.on('update', (e) => {

        content__priceRange.closest('.item__container').querySelector('#price-range__min').value = Math.floor(e[0]);
        content__priceRange.closest('.item__container').querySelector('#price-range__min').max = Math.floor(e[1]);
        content__priceRange.closest('.item__container').querySelector('#price-range__max').value = Math.floor(e[1]);
        content__priceRange.closest('.item__container').querySelector('#price-range__max').min = Math.floor(e[0]);

    })

    if(content__priceRange.closest('.item__container').querySelector('#price-range__min')){

        content__priceRange.closest('.item__container').querySelector('#price-range__min').addEventListener('keyup', (e) => {

            if(Number(e.target.value) > Number(e.target.max)){

                e.target.value = Number(e.target.max);

            }else if(Number(e.target.value) < Number(e.target.min)){

                e.target.value = Number(e.target.min)

            }

        })

    }

}

if(document.querySelector('#content__price-range__mobile')){

    var content__priceRange__mobile = document.getElementById('content__price-range__mobile');

    noUiSlider.create(content__priceRange__mobile, {
        start: [27730, 547480],
        connect: true,
        step: 10,
        range: {
            'min': 1000,
            'max': 800000
        }
    });

    content__priceRange__mobile.noUiSlider.on('update', (e) => {

        content__priceRange__mobile.closest('.item__container').querySelector('#price-range__min__mobile').value = Math.floor(e[0]);
        content__priceRange__mobile.closest('.item__container').querySelector('#price-range__min__mobile').max = Math.floor(e[1]);
        content__priceRange__mobile.closest('.item__container').querySelector('#price-range__max__mobile').value = Math.floor(e[1]);
        content__priceRange__mobile.closest('.item__container').querySelector('#price-range__max__mobile').min = Math.floor(e[0]);

    })

    if(content__priceRange__mobile.closest('.item__container').querySelector('#price-range__min__mobile')){

        content__priceRange__mobile.closest('.item__container').querySelector('#price-range__min__mobile').addEventListener('keyup', (e) => {

            if(Number(e.target.value) > Number(e.target.max)){

                e.target.value = Number(e.target.max);

            }else if(Number(e.target.value) < Number(e.target.min)){

                e.target.value = Number(e.target.min)

            }

        })

    }

}

if(document.querySelector('.button__filter-activator')){

    let filterActivators = document.querySelectorAll('.button__filter-activator');

    filterActivators.forEach(activator => {

        activator.addEventListener('click', (e) => {

            if(e.target.closest('.catalog__tabs-filter').querySelector('.tabs-filter').classList.contains('active')){

                e.target.closest('.catalog__tabs-filter').querySelector('.tabs-filter').classList.remove('active');
                document.querySelector('body').classList.remove('mobile-filter-active');

            }else{

                e.target.closest('.catalog__tabs-filter').querySelector('.tabs-filter').classList.add('active');
                document.querySelector('body').classList.add('mobile-filter-active');

            }

        })

    });

}

if(document.querySelector('.catalog__tabs-filter')){

    let lastScrollTop = 0;
    const block = document.querySelector('.catalog__tabs-filter.mobile');
    window.addEventListener('scroll', () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if(scrollTop>300){
        block.style.position = 'fixed';
        if (scrollTop > lastScrollTop) {
            block.style.top = `-${block.offsetHeight}px`;
        } else {
            block.style.top = '79px';
        }
        lastScrollTop = scrollTop;
    }else{
        block.style.position = 'static';
    }
    });

}

if(document.querySelector('#productSlider')){
// Инициализация превью слайдера
const productSliderPreview = new Swiper("#productSliderPreview", {
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true,
});
const productSlider = new Swiper("#productSlider", {
    spaceBetween: 10,
    /* navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    }, */
    thumbs: {
        swiper: productSliderPreview,
    },
    // If we need pagination
    pagination: {
        el: '.single-product-slider-pagination',
    },
});
}

if(document.querySelector('#articles-slider')){

    const articlesSlider = new Swiper('#articles-slider', {
        // Optional parameters
        direction: 'horizontal',
        /* loop: true, */
        slidesPerView:'auto',
        spaceBetween: 30,
        slidesPerGroup: 3,

        breakpoints: {
            // when window width is >= 320px
            1200: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3
            },
            759: {
                slidesPerView: 3,
                spaceBetween: 30,
                slidesPerGroup: 3
            },
            420: {
                slidesPerView: 2,
                spaceBetween: 15,
                slidesPerGroup: 2
            },
            0: {
                slidesPerView: 1,
                spaceBetween: 15,
                slidesPerGroup: 1
            }
        },

        // Navigation arrows
        navigation: {
          nextEl: '.articles-slider-button-next',
          prevEl: '.articles-slider-button-prev',
        },

        // If we need pagination
        pagination: {
            el: '.articles-slider-pagination',
        },

    });

}

if(document.querySelectorAll('.cms-content__slider .swiper').length>0){

    document.querySelectorAll('.cms-content__slider').forEach(slider => {

        let currentSliderId = Math.floor(Math.random() * Date.now());

        slider.querySelector('.swiper-button-next').classList.add('cms-content__slider_' + currentSliderId);
        slider.querySelector('.swiper-button-prev').classList.add('cms-content__slider_' + currentSliderId);
        slider.querySelector('.swiper-pagination').classList.add('cms-content__slider_' + currentSliderId);

        slider = new Swiper(slider.querySelector('.swiper'), {
            // Optional parameters
            direction: 'horizontal',
            /* loop: true, */
            slidesPerView:1,
            spaceBetween: 30,
            slidesPerGroup: 1,

            breakpoints: {
                // when window width is >= 320px
                1200: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    slidesPerGroup: 1
                },
                759: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    slidesPerGroup: 1
                },
                0: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                    slidesPerGroup: 1
                }
            },

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next.cms-content__slider_' + currentSliderId,
              prevEl: '.swiper-button-prev.cms-content__slider_' + currentSliderId,
            },

            // If we need pagination
            pagination: {
                el: '.swiper-pagination.cms-content__slider_' + currentSliderId,
            },

        });

    })

}

if(document.getElementById('info-form')){
    let form = document.getElementById('info-form')
    form.addEventListener('keyup', (e)=>{
        form.querySelector('.input__submit button').classList.remove('btn-disabled');
    })
}

new NativejsSelect({
    selector: '.customSelect',
  });

if(document.querySelector('.phoneMask')){

    maskPhone('.phoneMask');

}

